// Persist the client's display name across visits (used by the public review page only).

const KEY = 'hsp_client_name';

export function getStoredClientName(): string {
  try {
    return localStorage.getItem(KEY) ?? '';
  } catch {
    return '';
  }
}

export function setStoredClientName(name: string): void {
  try {
    localStorage.setItem(KEY, name);
  } catch {}
}
